import { create } from "zustand";
import { persist } from "zustand/middleware";

const useEmployeeIdStore = create(
  persist(
    (set) => ({
      employeeId: null,
      eachEmployeeInfo: null, 
      
      setEachEmployeeInfo: (info) => set({ eachEmployeeInfo: info }),
      setEmployeeId: (id) => set({ employeeId: id }),
      clearEmployeeId: () => set({ employeeId: null }),
      clearEmployeeInfo: () => set({ eachEmployeeInfo: null }),
      clearAll: () => set({ employeeId: null, eachEmployeeInfo: null }),
    }),
    {
      name: "employee-store", 
      partialize: (state) => ({
        employeeId: state.employeeId,
        eachEmployeeInfo: state.eachEmployeeInfo,
      }),
     
    }
  )
);

export default useEmployeeIdStore;